import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Turborepo 2.3",
  "description": "Turborepo 2.3은 Boundaries RFC와 함께 여러 인간공학적 개선 사항을 소개합니다.",
  "date": "2024/11/14",
  "tag": "web development"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo 2.3은 여러 인간공학적 개선 사항을 소개합니다:"
  }, {
    "heading": "",
    "content": "Boundaries RFC: 개발자 경험을 유지하기 위한 제약 조건 적용"
  }, {
    "heading": "",
    "content": "패키지 작업 단축키: turbo run package#task로 작업 실행"
  }, {
    "heading": "",
    "content": "간소화된 캐시 제어: 단일 플래그를 사용한 캐시 소스의 더 쉬운 관리"
  }, {
    "heading": "",
    "content": "npx @turbo/codemod migrate를 실행하여 지금 업데이트하거나 npx create-turbo@latest로 시작하세요."
  }, {
    "heading": "boundaries-rfc",
    "content": "Monorepo는 더 빠른 반복 속도와 놀라운 유연성을 제공하지만 새로운 도전 과제도 도입합니다:"
  }, {
    "heading": "boundaries-rfc",
    "content": "패키지의 공개 API가 존중되는지 어떻게 확인합니까?"
  }, {
    "heading": "boundaries-rfc",
    "content": "코드를 사용할 수 있는 위치와 사용할 수 없는 위치를 모든 개발자에게 어떻게 전달합니까?"
  }, {
    "heading": "boundaries-rfc",
    "content": "패키지가 올바른 컨텍스트에서만 사용되도록 어떻게 보장할 수 있습니까?"
  }, {
    "heading": "boundaries-rfc",
    "content": "이는 monorepo에서 구축할 때 핵심 질문의 몇 가지 예일 뿐입니다: Workspace의 구조적 무결성을 어떻게 전달하고 시행합니까?"
  }, {
    "heading": "boundaries-rfc",
    "content": "이 게시물을 게시할 당시 Boundaries RFC는 초기 초안일 뿐입니다. 아래에 설명된\n구현은 변경될 수 있습니다. 최신 정보는 RFC 자체를 참조하세요."
  }, {
    "heading": "boundaries-rfc",
    "content": "Boundaries RFC는 이 문제에 대한 우리의 초기 제안입니다. 현재 접근 방식에서는 한 줄의 코드로 Boundaries를 점진적으로 채택할 수 있기를 원합니다:"
  }, {
    "heading": "boundaries-rfc",
    "content": "또한 사용자 정의 Boundaries로 도메인, 관심사, 컨텍스트 및 기타 유용한 메타데이터를 표시할 수 있는 태그 시스템을 만들고자 합니다."
  }, {
    "heading": "boundaries-rfc",
    "content": "또한 플래그로 기존 진단을 허용 목록에 추가할 수 있도록 계획하고 있습니다:"
  }, {
    "heading": "boundaries-rfc",
    "content": "이렇게 하면 새 코드에 대한 Boundaries를 시행하고 기존 문제를 점진적으로 수정할 수 있습니다."
  }, {
    "heading": "boundaries-rfc",
    "content": "Boundaries RFC에 대한 여러분의 아이디어와 피드백을 기대합니다."
  }, {
    "heading": "패키지-작업-단축키",
    "content": "이제 정규화된 작업 식별자를 사용하여 작업을 실행할 수 있습니다:"
  }, {
    "heading": "패키지-작업-단축키",
    "content": "이는 --filter를 사용하는 동등한 명령(turbo run build --filter=web)보다 편리하며 여러 작업을 타겟팅하려는 경우 더 정확합니다:"
  }, {
    "heading": "패키지-작업-단축키",
    "content": "문서에서 자세히 알아보세요."
  }, {
    "heading": "간소화된-캐시-제어",
    "content": "이전에는 --remote-only 및 --no-cache 플래그가 출력 아티팩트의 소스 및 캐싱을 관리하는 데 사용되었습니다. 그러나 이들이 혼란을 야기할 수 있으며 로컬 및 Remote Cache에 대한 읽기 및 쓰기 제어에 격차가 있음을 확인했습니다."
  }, {
    "heading": "간소화된-캐시-제어",
    "content": "이를 개선하기 위해 이러한 플래그를 통합하고 더 많은 기능을 제공하는 새로운 --cache 플래그를 도입했습니다."
  }, {
    "heading": "간소화된-캐시-제어",
    "content": "local 및 remote를 사용하여 turbo 호출의 읽기 및 쓰기 동작을 제어할 수 있습니다. 문서에서 자세히 알아보세요."
  }, {
    "heading": "turbo-query에-대한-지속적인-개선",
    "content": "2.2에서 패키지 및 작업 그래프에 대한 Turborepo의 지식을 사용하여 저장소를 검사하기 위해 구축된 기능인 turbo query를 도입했습니다. 더욱 강력한 쿼리를 제공하기 위해 이 기능을 추가로 반복했습니다:"
  }, {
    "heading": "turbo-query에-대한-지속적인-개선",
    "content": "특정 파일에 의존하는 파일을 찾기 위한 역방향 파일 추적 구현"
  }, {
    "heading": "turbo-query에-대한-지속적인-개선",
    "content": "타입 전용 의존성을 찾기 위한 파일 추적 필터"
  }, {
    "heading": "turbo-query에-대한-지속적인-개선",
    "content": "제공한 패키지 이름이 존재하는지 확인하기 위한 유효성 검사"
  }, {
    "heading": "커뮤니티",
    "content": "Turborepo 2.2 출시 이후 훌륭한 채택과 커뮤니티 성장을 보았습니다:"
  }, {
    "heading": "커뮤니티",
    "content": "26.3+ GitHub Stars"
  }, {
    "heading": "커뮤니티",
    "content": "3.4M+ 주간 NPM 다운로드"
  }, {
    "heading": "커뮤니티",
    "content": "Vercel Remote Cache를 사용하여 496년의 컴퓨팅 시간 절약"
  }, {
    "heading": "커뮤니티",
    "content": "Turborepo는 핵심 팀을 포함한 모든 기여자들의 결합된 작업의 결과입니다: Anthony, Chris, Nicholas, 그리고 Tom."
  }, {
    "heading": "커뮤니티",
    "content": "Turborepo를 여러분의 빌드 도구로 만들어 주시는 지속적인 지원, 피드백 및 협력에 감사드립니다."
  }],
  "headings": [{
    "id": "boundaries-rfc",
    "content": "Boundaries RFC"
  }, {
    "id": "패키지-작업-단축키",
    "content": "패키지 작업 단축키"
  }, {
    "id": "간소화된-캐시-제어",
    "content": "간소화된 캐시 제어"
  }, {
    "id": "turbo-query에-대한-지속적인-개선",
    "content": "turbo query에 대한 지속적인 개선"
  }, {
    "id": "커뮤니티",
    "content": "커뮤니티"
  }]
};
import {Authors} from '#components/authors';
import {Date} from '#components/blog/date';
import {Tab, Tabs} from '#components/tabs';
import {Callout} from '#components/callout';
export const toc = [{
  depth: 2,
  url: "#boundaries-rfc",
  title: _jsx(_Fragment, {
    children: "Boundaries RFC"
  })
}, {
  depth: 2,
  url: "#패키지-작업-단축키",
  title: _jsx(_Fragment, {
    children: "패키지 작업 단축키"
  })
}, {
  depth: 2,
  url: "#간소화된-캐시-제어",
  title: _jsx(_Fragment, {
    children: "간소화된 캐시 제어"
  })
}, {
  depth: 2,
  url: "#turbo-query에-대한-지속적인-개선",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "turbo query"
    }), "에 대한 지속적인 개선"]
  })
}, {
  depth: 2,
  url: "#커뮤니티",
  title: _jsx(_Fragment, {
    children: "커뮤니티"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx("h1", {
      className: "text-center",
      children: "Turborepo 2.3"
    }), "\n", "\n", _jsx(Date, {
      children: "Tuesday, November 14th, 2024"
    }), "\n", _jsx(Authors, {
      authors: ['chrisolszewski', 'nicholasyang', 'anthonyshew']
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 2.3은 여러 인간공학적 개선 사항을 소개합니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#boundaries-rfc",
          children: _jsx(_components.strong, {
            children: "Boundaries RFC"
          })
        }), ": 개발자 경험을 유지하기 위한 제약 조건 적용"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#package-task-shortcuts",
          children: _jsx(_components.strong, {
            children: "패키지 작업 단축키"
          })
        }), ": ", _jsx(_components.code, {
          children: "turbo run package#task"
        }), "로 작업 실행"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#simplified-cache-control",
          children: _jsx(_components.strong, {
            children: "간소화된 캐시 제어"
          })
        }), ": 단일 플래그를 사용한 캐시 소스의 더 쉬운 관리"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "npx @turbo/codemod migrate"
      }), "를 실행하여 지금 업데이트하거나 ", _jsx(_components.code, {
        children: "npx create-turbo@latest"
      }), "로 시작하세요."]
    }), "\n", _jsx(_components.h2, {
      id: "boundaries-rfc",
      children: "Boundaries RFC"
    }), "\n", _jsx(_components.p, {
      children: "Monorepo는 더 빠른 반복 속도와 놀라운 유연성을 제공하지만 새로운 도전 과제도 도입합니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "패키지의 공개 API가 존중되는지 어떻게 확인합니까?"
      }), "\n", _jsx(_components.li, {
        children: "코드를 사용할 수 있는 위치와 사용할 수 없는 위치를 모든 개발자에게 어떻게 전달합니까?"
      }), "\n", _jsx(_components.li, {
        children: "패키지가 올바른 컨텍스트에서만 사용되도록 어떻게 보장할 수 있습니까?"
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "이는 monorepo에서 구축할 때 핵심 질문의 몇 가지 예일 뿐입니다: Workspace의 구조적 무결성을 어떻게 전달하고 시행합니까?"
    }), "\n", _jsx(Callout, {
      type: "info",
      children: _jsx(_components.p, {
        children: "이 게시물을 게시할 당시 Boundaries RFC는 초기 초안일 뿐입니다. 아래에 설명된\n구현은 변경될 수 있습니다. 최신 정보는 RFC 자체를 참조하세요."
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://github.com/vercel/turborepo/discussions/9435",
        children: "Boundaries RFC"
      }), "는 이 문제에 대한 우리의 초기 제안입니다. 현재 접근 방식에서는 한 줄의 코드로 Boundaries를 점진적으로 채택할 수 있기를 원합니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"boundaries\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "또한 사용자 정의 Boundaries로 도메인, 관심사, 컨텍스트 및 기타 유용한 메타데이터를 표시할 수 있는 태그 시스템을 만들고자 합니다."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "apps/ui/turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"extends\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"//\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"boundaries\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"tags\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"library\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"ui\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"frontend\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"beta\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"allowDependencyOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"library\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"frontend\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"denyDependencyFrom\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"backend\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"stable\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "또한 플래그로 기존 진단을 허용 목록에 추가할 수 있도록 계획하고 있습니다:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " boundaries"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --exclude-errors"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "이렇게 하면 새 코드에 대한 Boundaries를 시행하고 기존 문제를 점진적으로 수정할 수 있습니다."
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://github.com/vercel/turborepo/discussions/9435",
        children: "Boundaries RFC"
      }), "에 대한 여러분의 아이디어와 피드백을 기대합니다."]
    }), "\n", _jsx(_components.h2, {
      id: "패키지-작업-단축키",
      children: "패키지 작업 단축키"
    }), "\n", _jsx(_components.p, {
      children: "이제 정규화된 작업 식별자를 사용하여 작업을 실행할 수 있습니다:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " web#build"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["이는 ", _jsx(_components.code, {
        children: "--filter"
      }), "를 사용하는 동등한 명령(", _jsx(_components.code, {
        children: "turbo run build --filter=web"
      }), ")보다 편리하며 여러 작업을 타겟팅하려는 경우 더 정확합니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " web#build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " docs#lint"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.a, {
        href: "/docs/crafting-your-repository/running-tasks#filtering-by-package",
        children: "문서에서 자세히 알아보세요."
      })
    }), "\n", _jsx(_components.h2, {
      id: "간소화된-캐시-제어",
      children: "간소화된 캐시 제어"
    }), "\n", _jsxs(_components.p, {
      children: ["이전에는 ", _jsx(_components.code, {
        children: "--remote-only"
      }), " 및 ", _jsx(_components.code, {
        children: "--no-cache"
      }), " 플래그가 출력 아티팩트의 소스 및 캐싱을 관리하는 데 사용되었습니다. 그러나 이들이 혼란을 야기할 수 있으며 로컬 및 Remote Cache에 대한 읽기 및 쓰기 제어에 격차가 있음을 확인했습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["이를 개선하기 위해 이러한 플래그를 통합하고 더 많은 기능을 제공하는 새로운 ", _jsx(_components.code, {
        children: "--cache"
      }), " 플래그를 도입했습니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --cache=local:rw,remote:r"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "local"
      }), " 및 ", _jsx(_components.code, {
        children: "remote"
      }), "를 사용하여 ", _jsx(_components.code, {
        children: "turbo"
      }), " 호출의 읽기 및 쓰기 동작을 제어할 수 있습니다. ", _jsx(_components.a, {
        href: "/docs/reference/run#--cache-options",
        children: "문서"
      }), "에서 자세히 알아보세요."]
    }), "\n", _jsxs(_components.h2, {
      id: "turbo-query에-대한-지속적인-개선",
      children: [_jsx(_components.code, {
        children: "turbo query"
      }), "에 대한 지속적인 개선"]
    }), "\n", _jsxs(_components.p, {
      children: ["2.2에서 패키지 및 작업 그래프에 대한 Turborepo의 지식을 사용하여 저장소를 검사하기 위해 구축된 기능인 ", _jsx(_components.code, {
        children: "turbo query"
      }), "를 도입했습니다. 더욱 강력한 쿼리를 제공하기 위해 이 기능을 추가로 반복했습니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "특정 파일에 의존하는 파일을 찾기 위한 역방향 파일 추적 구현"
      }), "\n", _jsx(_components.li, {
        children: "타입 전용 의존성을 찾기 위한 파일 추적 필터"
      }), "\n", _jsx(_components.li, {
        children: "제공한 패키지 이름이 존재하는지 확인하기 위한 유효성 검사"
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "커뮤니티",
      children: "커뮤니티"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/blog/turbo-2-2-0",
        children: "Turborepo 2.2"
      }), " 출시 이후 훌륭한 채택과 커뮤니티 성장을 보았습니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo",
          children: "26.3+ GitHub Stars"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://www.npmjs.com/package/turbo",
          children: "3.4M+ 주간 NPM 다운로드"
        })
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "https://vercel.com/docs/concepts/monorepos/remote-caching",
          children: "Vercel Remote Cache"
        }), "를 사용하여 496년의 컴퓨팅 시간 절약"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo는 핵심 팀을 포함한 모든 기여자들의 결합된 작업의 결과입니다: ", _jsx(_components.a, {
        href: "https://github.com/anthonyshew",
        children: "Anthony"
      }), ", ", _jsx(_components.a, {
        href: "https://github.com/chris-olszewski",
        children: "Chris"
      }), ", ", _jsx(_components.a, {
        href: "https://github.com/NicholasLYang",
        children: "Nicholas"
      }), ", 그리고 ", _jsx(_components.a, {
        href: "https://github.com/tknickman",
        children: "Tom"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "Turborepo를 여러분의 빌드 도구로 만들어 주시는 지속적인 지원, 피드백 및 협력에 감사드립니다."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
